var TYPE_UNDEF = 'undefined',
PROTO = 'prototype',
fitt = require('fitt'),
fittForEach = fitt.forEach,
cnum = fitt.cnum,
cstr = fitt.cstr,
mix = fitt.mix,
strlc = fitt.strlc,
idxOf = fitt.idxOf,
keys = fitt.keys,
subStr = fitt.subStr,
fittDOM = require('fitt-dom'),
fittDOMCreate = fittDOM.make,
fittDOMAttr = fittDOM.attr,
clsURL = require('fitt-url').URL,
sendRequest = require('./core/sendRequest.js'),
defaults = require('./core/defaults.js'),
Canceler = require('./core/canceler.js'),
debug = require('debug')('fitt-http'),
oFITTHTTP = null,

CACHE_CONTROL_HEADER = 'cache-control',
CACHE_CONTROL_HEADER_PROP = 'cacheControl',
CACHE_CONTROL_HEADER_PROP_LC = strlc(CACHE_CONTROL_HEADER_PROP, true),
MAX_AGE_SUB_HEADER = 'max-age',
MAX_AGE_SUB_HEADER_PROP = 'maxAge',
MAX_AGE_SUB_HEADER_PROP_LC = strlc(MAX_AGE_SUB_HEADER_PROP, true);

/**
                                                                    * Lightweight isomorphic HTTP requester<br><br>
                                                                    *
                                                                    * Config supports:<br>
                                                                    * baseURL(instances)<br>
                                                                    * request cancellation<br>
                                                                    * request headers<br>
                                                                    * timeout<br>
                                                                    * response data transforms<br>
                                                                    * success validation<br><br>
                                                                    *
                                                                    * Usage:<br>
                                                                    * <pre>
                                                                     	http.get('http://httpbin.org/get');
                                                                     	var canceler = http.getCanceler();
                                                                    	http.post('http://httpbin.org/post',
                                                                    			{canceler: canceler, data: {key1: 'value1', key2: 'value2'}})
                                                                     		.then(function(data) {
                                                                     			console.log(data);
                                                                    		})
                                                                    		.catch(function(reason) {
                                                                    			console.log(reason);
                                                                    		});
                                                                     	canceler.cancel('I changed my mind.');
                                                                    * </pre>
                                                                    *
                                                                    * @class
                                                                    * @name fitt.http
                                                                    * @param {Object} defaultConfig Contains default configuration options
                                                                    */

function http(defaultConfig) {
  this.defaults = defaultConfig ? mix({}, [defaults, defaultConfig]) : mix({}, defaults);
}

/**
   * Main request method
   *
   * @name fitt.http#request
   * @function
   * @public
   * @param {String} url The resource to request
   * @param {Object} config The object containing all incoming config parameters
   * @return {Promise}
   */

http[PROTO].request = function (url, config) {

  var newURL, confBaseURL;

  config = mix(config, [defaults, this.defaults, config], false, false, true, true);
  confBaseURL = config.baseURL;

  // Support baseURL config
  if (confBaseURL && !clsURL.isAbsolute(url)) {
    //input url is a path that's relative so treat it as such
    newURL = new clsURL(confBaseURL, '', cstr(url));
    if (!newURL.isValid()) {
      throw new Error('Invalid URL input specified base:' + confBaseURL + ', input url:' + cstr(url));
    }
    url = cstr(newURL);
  }

  debug('request', url);

  return sendRequest(url, config);
};

/**
    * Returns a Canceler object to be used should you need to cancel a request
    *
    * @name fitt.http#getCanceler
    * @function
    * @public
    * @return {Canceler}
    */

http[PROTO].getCanceler = function () {
  return new Canceler();
};

/**
    * Convenience methods for supported request types
    *
    * @name fitt.http#get
    * @function
    * @public
    * @param {String} url The resource to request
    * @param {Object} config The object containing all incoming config parameters
    * @return {Promise}
    */
/**
        * @name fitt.http#delete
        * @function
        * @public
        * @param {String} url The resource to request
        * @param {Object} config The object containing all incoming config parameters
        * @return {Promise}
        */
/**
            * @name fitt.http#head
            * @function
            * @public
            * @param {String} url The resource to request
            * @param {Object} config The object containing all incoming config parameters
            * @return {Promise}
            */
/**
                * @name fitt.http#post
                * @function
                * @public
                * @param {String} url The resource to request
                * @param {Object} data The object containing all key/value data pairs
                * @param {Object} config The object containing all incoming config parameters
                * @return {Promise}
                */
/**
                    * @name fitt.http#put
                    * @function
                    * @public
                    * @param {String} url The resource to request
                    * @param {Object} data The object containing all key/value data pairs
                    * @param {Object} config The object containing all incoming config parameters
                    * @return {Promise}
                    */
/**
                        * @name fitt.http#patch
                        * @function
                        * @public
                        * @param {String} url The resource to request
                        * @param {Object} data The object containing all key/value data pairs
                        * @param {Object} config The object containing all incoming config parameters
                        * @return {Promise}
                        */

// Provide aliases for supported request methods
fittForEach(['delete', 'get', 'head'], function (method) {
  http[PROTO][method] = function (url, config) {
    return this.request(url, mix(config || {}, {
      method: method }));

  };
});

fittForEach(['post', 'put', 'patch'], function (method) {
  http[PROTO][method] = function (url, data, config) {
    return this.request(url, mix(config || {}, {
      method: method,
      data: data }));

  };
});


/**
     * Retrieve and insert a script into browser document
     *
     * @name fitt.http#script
     * @function
     * @public
     * @param {String} url The script to request and execute
     * @return {Promise}
     */

http[PROTO].script = function (url, attributes) {
  return new Promise(function (resolve, reject) {
    var oScpt = fittDOMCreate('script') || {};

    fittForEach(attributes, function (value, name) {
      fittDOMAttr(oScpt, name, value);
    });

    oScpt.onload = function () {
      resolve();
    };
    oScpt.onerror = function (e) {
      reject(e);
    };

    oScpt.src = url;

    fittDOM.append(fittDOM.head(), oScpt);
  });
};

/**
    * Search a string or object (typically a representation of an HTTP header), for a 'max-age' cache control directive.
    *
    * @name fitt.http.parseMaxAge
    * @function
    * @param {Object|String} header  If input is a string, searches the string for max-age and returns that numeric value if available.
    *								  If input is an object, it can be a 'headers' object from a standard http response, containing the
    *								  keys mapping to each header entry, and their respective values, in which cache a 'cache-control' header
    *								  is looked for and then max age is parsed from the value of that entry.  Altrenatively it could be an object
    *								  of a header item itself, and in that case a 'max-age' property is looked for and it's numeric value is returned.
    *								  In either case, the property names are normalized to lower case to avoid issues not finding the key in an object
    * 								  or string that is formatted slightly different than standard.
    *
    * @param {Number} [defaultValue=0] Optionally allows you to pass a custom default value to be used in case a 'max-age' value cannot be found.
    * @return {Number}
   */

function parseMaxAge(header, defaultValue)
{
  var headerType = header && typeof header || '',
  strIndex = -1,
  foundSomething = false,
  breakLoop = false,
  headerKeyIndex = 0,
  headerKeyCount = 0,
  subStrStart = 0,
  ret,headerStr,headerKeys,headerKey,headerKeyLC,headerVal;

  if (headerType) {
    if (headerType === 'object') {
      if (MAX_AGE_SUB_HEADER_PROP in header) {
        /* look for [obj].maxAge */

        ret = cnum(header[MAX_AGE_SUB_HEADER_PROP], 0, 0);
        foundSomething = true;

      } else if (MAX_AGE_SUB_HEADER_PROP_LC in header) {
        /* look for [obj].maxage */

        ret = cnum(header[MAX_AGE_SUB_HEADER_PROP_LC], 0, 0);
        foundSomething = true;
      } else if (MAX_AGE_SUB_HEADER in header) {
        /* look for [obj]['max-age'] */

        ret = cnum(header[MAX_AGE_SUB_HEADER], 0, 0);
      } else if (CACHE_CONTROL_HEADER in header) {
        /* look for [obj]['cache-control'] */

        headerStr = header[CACHE_CONTROL_HEADER];
        ret = parseMaxAge(headerStr, defaultValue);
        foundSomething = true;
      } else if (CACHE_CONTROL_HEADER_PROP in header) {
        /* look for [obj]['cacheControl'], recurse down one level */

        headerStr = header[CACHE_CONTROL_HEADER_PROP];
        ret = parseMaxAge(headerStr, defaultValue);
        foundSomething = true;
      } else if (CACHE_CONTROL_HEADER_PROP_LC in header) {
        /* look for [obj]['cachecontrol'], recurse down one level */

        headerStr = header[CACHE_CONTROL_HEADER_PROP_LC];
        ret = parseMaxAge(headerStr, defaultValue);
        foundSomething = true;
      } else {
        /* nothing found, so either 'cache-control' or 'max-age' may be formatted with camel case
               * or some other weirdness, so iterate over the keys of the object
              */

        headerKeys = keys(header);
        headerKeyCount = headerKeys.length;
        for (; headerKeyIndex < headerKeyCount; headerKeyIndex++)
        {
          headerKey = headerKeys[headerKeyIndex];
          headerVal = header[headerKey];
          headerKeyLC = strlc(headerKey, true);

          switch (headerKeyLC) {

            case MAX_AGE_SUB_HEADER:
            case MAX_AGE_SUB_HEADER_PROP:
            case MAX_AGE_SUB_HEADER_PROP_LC:
              /* matches any of the same above formats for max-age */

              ret = cnum(headerVal, 0, 0);
              foundSomething = true;
              breakLoop = true;
              break;
            case CACHE_CONTROL_HEADER:
            case CACHE_CONTROL_HEADER_PROP:
            case CACHE_CONTROL_HEADER_PROP_LC:
              /* found a cache-control entry, so now recurse down one level
                                                * and get max-age out of it
                                               */

              breakLoop = true;
              ret = parseMaxAge(headerVal, defaultValue);
              foundSomething = true;
              break;}


          if (breakLoop) {
            break;
          }
        }
      }
    } else {
      headerStr = strlc(header);
      strIndex = idxOf(headerStr, MAX_AGE_SUB_HEADER + '=');
      subStrStart = strIndex != -1 ? strIndex + MAX_AGE_SUB_HEADER.length + 1 : 0;

      if (strIndex === -1) {
        strIndex = idxOf(headerStr, MAX_AGE_SUB_HEADER + ':');
        subStrStart = strIndex != -1 ? strIndex + MAX_AGE_SUB_HEADER.length + 1 : 0;
      }

      if (strIndex === -1) {
        strIndex = idxOf(headerStr, MAX_AGE_SUB_HEADER_PROP_LC + '=');
        subStrStart = strIndex != -1 ? strIndex + MAX_AGE_SUB_HEADER_PROP_LC.length + 1 : 0;
      }

      if (strIndex === -1) {
        strIndex = idxOf(headerStr, MAX_AGE_SUB_HEADER_PROP_LC + ':');
        subStrStart = strIndex != -1 ? strIndex + MAX_AGE_SUB_HEADER_PROP_LC.length + 1 : 0;
      }

      if (strIndex !== -1) {
        ret = cnum(subStr(headerStr, subStrStart), false, 0);
        if (ret !== false) {
          foundSomething = true;
        }
      }
    }
  }

  if (!foundSomething) {
    defaultValue = cnum(defaultValue, 0, 0);
    ret = defaultValue;
  }

  return ret;
}

/* no need to document parseMaxAge function as it's documented
   * in the file itself
  */

http[PROTO].parseMaxAge = parseMaxAge;

oFITTHTTP = new http();

if (typeof module !== TYPE_UNDEF) {
  module.exports = oFITTHTTP;
}

fitt.ns("fitt.http", oFITTHTTP);


//////////////////
// WEBPACK FOOTER
// ../~/espn-fitt/es5/fitt-http/index.js
// module id = 811
// module chunks = 0